var _path, _path2, _path3, _g, _g2, _path4, _g3, _rect, _rect2, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _g4, _rect3, _rect4, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _g5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3102_20111)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.4C0 3.31309 3.31309 0 7.4 0H36.6C40.6869 0 44 3.31309 44 7.4V36.6C44 40.6869 40.6869 44 36.6 44H7.4C3.31309 44 0 40.6869 0 36.6V7.4Z",
    fill: "url(#paint0_linear_3102_20111)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.8296 45.6858L48.9119 48.7681L48.768 48.912L45.6857 45.8297V48.84H45.4822V45.6858H33.4757V48.84H33.2722V45.6858H24.5217V48.84H24.3182V45.6858H15.5677V48.84H15.3642V45.6858H3.35775V48.84H3.15425V45.8297L0.0719443 48.912L-0.0719519 48.7681L3.01035 45.6858H-3.8147e-06V45.4823H3.15425V33.4758H-3.8147e-06V33.2723H3.15425V24.5218H-3.8147e-06V24.3183H3.15425V15.5678H-3.8147e-06V15.3643H3.15425V3.35775H-3.8147e-06V3.15425H3.01034L-0.0719604 0.0719511L0.0719376 -0.0719452L3.15425 3.01036V2.92808e-06H3.35775V3.15425H15.3642V2.92808e-06H15.5677V3.15425H24.3182V2.92808e-06H24.5217V3.15425H33.2722V2.92808e-06H33.4757V3.15425H45.4822V2.92808e-06H45.6857V3.01036L48.768 -0.0719452L48.9119 0.0719511L45.8296 3.15425H48.84V3.35775H45.6857V15.3643H48.84V15.5678H45.6857V24.3183H48.84V24.5218H45.6857V33.2723H48.84V33.4758H45.6857V45.4823H48.84V45.6858H45.8296ZM45.4822 45.3384V33.4758H43.6668C42.6284 35.6789 41.2228 37.675 39.5289 39.385L45.4822 45.3384ZM39.385 39.2411C41.0401 37.5701 42.4173 35.6233 43.4415 33.4758H33.9215C33.8724 33.5273 33.8229 33.5784 33.773 33.6291L39.385 39.2411ZM33.6291 33.773L39.2411 39.385C37.5701 41.0401 35.6233 42.4173 33.4757 43.4415V33.9215C33.5273 33.8724 33.5784 33.8229 33.6291 33.773ZM33.6291 33.4852C33.6322 33.482 33.6353 33.4789 33.6384 33.4758H33.6196L33.6291 33.4852ZM33.4757 33.6197L33.4852 33.6291C33.482 33.6322 33.4789 33.6353 33.4757 33.6384V33.6197ZM33.2722 33.1284V26.3379C32.9064 28.0345 32.0652 29.5543 30.8949 30.751L33.2722 33.1284ZM30.751 30.8949L33.1283 33.2723H26.3379C28.0345 32.9064 29.5543 32.0652 30.751 30.8949ZM30.751 30.6071C32.2889 29.0337 33.245 26.8894 33.2717 24.5218H24.6656L30.751 30.6071ZM24.5217 24.6657L30.6071 30.751C29.0337 32.2889 26.8894 33.245 24.5217 33.2717V24.6657ZM24.3182 24.1744V15.5683C21.9506 15.595 19.8063 16.5511 18.2329 18.089L24.3182 24.1744ZM18.089 18.2329L24.1743 24.3183H15.5683C15.595 21.9506 16.5511 19.8063 18.089 18.2329ZM18.089 17.9451C19.2856 16.7748 20.8055 15.9336 22.5021 15.5678H15.7116L18.089 17.9451ZM15.5677 15.7117L17.9451 18.089C16.7748 19.2857 15.9336 20.8055 15.5677 22.5021V15.7117ZM15.3642 15.2204V15.2017C15.3611 15.2047 15.358 15.2078 15.3548 15.2109L15.3642 15.2204ZM15.2109 15.3548L15.2203 15.3643H15.2016C15.2047 15.3611 15.2078 15.358 15.2109 15.3548ZM15.2109 15.067C15.2616 15.0171 15.3127 14.9676 15.3642 14.9185V5.39847C13.2167 6.42269 11.2699 7.79987 9.59885 9.45497L15.2109 15.067ZM9.45496 9.59887L15.067 15.2109C15.0171 15.2616 14.9676 15.3127 14.9185 15.3643H5.39847C6.42268 13.2167 7.79986 11.2699 9.45496 9.59887ZM9.45496 9.31107C11.165 7.61723 13.1611 6.21164 15.3642 5.17321V3.35775H3.50164L9.45496 9.31107ZM3.35775 3.50166L9.31106 9.45497C7.61722 11.165 6.21163 13.1611 5.1732 15.3643H3.35775V3.50166ZM39.385 39.5289L45.3383 45.4823H33.4757V43.6668C35.6789 42.6284 37.675 41.2228 39.385 39.5289ZM15.3642 45.4823H3.50164L9.45496 39.5289C11.165 41.2228 13.1611 42.6284 15.3642 43.6668V45.4823ZM3.35775 45.3384L9.31106 39.385C7.61722 37.675 6.21163 35.6789 5.1732 33.4758H3.35775V45.3384ZM15.3642 43.4415C13.2167 42.4173 11.2699 41.0401 9.59886 39.385L15.2109 33.773C15.2616 33.8229 15.3127 33.8724 15.3642 33.9215V43.4415ZM9.45496 39.2411L15.067 33.6291C15.0171 33.5784 14.9676 33.5273 14.9185 33.4758H5.39847C6.42269 35.6233 7.79987 37.5701 9.45496 39.2411ZM15.3642 33.6384L15.3548 33.6291L15.3642 33.6197V33.6384ZM15.2109 33.4852L15.2203 33.4758H15.2016L15.2109 33.4852ZM22.5021 33.2723H15.7116L18.089 30.8949C19.2857 32.0652 20.8055 32.9064 22.5021 33.2723ZM15.5677 33.1284L17.9451 30.751C16.7748 29.5543 15.9336 28.0345 15.5677 26.3379V33.1284ZM24.3182 33.2717C21.9506 33.245 19.8063 32.2889 18.2329 30.751L24.3182 24.6656V33.2717ZM18.089 30.6071L24.1744 24.5218H15.5683C15.595 26.8894 16.5511 29.0337 18.089 30.6071ZM33.2717 24.3183H24.6656L30.751 18.2329C32.2889 19.8063 33.245 21.9506 33.2717 24.3183ZM24.5217 24.1744L30.6071 18.089C29.0337 16.5511 26.8894 15.595 24.5217 15.5683V24.1744ZM33.2722 22.5021C32.9064 20.8055 32.0652 19.2857 30.8949 18.089L33.2722 15.7116V22.5021ZM30.751 17.9451L33.1283 15.5678H26.3379C28.0345 15.9336 29.5543 16.7748 30.751 17.9451ZM33.6383 15.3643H33.6196L33.6291 15.3548L33.6383 15.3643ZM33.4757 15.2204L33.4852 15.2109L33.4757 15.2017V15.2204ZM33.9215 15.3643C33.8724 15.3127 33.8229 15.2616 33.773 15.2109L39.385 9.59886C41.0401 11.2699 42.4173 13.2167 43.4415 15.3643H33.9215ZM33.6291 15.067L39.2411 9.45497C37.5701 7.79987 35.6233 6.42269 33.4757 5.39847V14.9185C33.5273 14.9676 33.5784 15.0171 33.6291 15.067ZM43.6668 15.3643C42.6284 13.1611 41.2228 11.165 39.5289 9.45497L45.4822 3.50165V15.3643H43.6668ZM39.385 9.31107L45.3383 3.35775H33.4757V5.17321C35.6789 6.21164 37.675 7.61722 39.385 9.31107ZM5.0786 33.2723H3.35775V27.3739C3.64639 29.451 4.23507 31.4322 5.0786 33.2723ZM14.7285 33.2723H5.30275C4.06786 30.6099 3.37276 27.6462 3.35799 24.5218H11.2946C11.3202 27.8928 12.6166 30.9615 14.7285 33.2723ZM15.3642 33.2723H15.006C12.8522 30.9826 11.5242 27.9071 11.4981 24.5218H15.3642V33.2723ZM15.5677 33.4758V33.834C17.8574 35.9878 20.9329 37.3158 24.3182 37.3419V33.4758H15.5677ZM24.5217 33.4758V37.3419C27.9071 37.3158 30.9826 35.9878 33.2722 33.834V33.4758H24.5217ZM33.834 33.2723H33.4757V24.5218H37.3419C37.3157 27.9071 35.9878 30.9826 33.834 33.2723ZM43.5372 33.2723H34.1115C36.2233 30.9615 37.5198 27.8928 37.5454 24.5218H45.482C45.4672 27.6462 44.7721 30.6099 43.5372 33.2723ZM45.4822 33.2723H43.7614C44.6049 31.4322 45.1936 29.451 45.4822 27.3739V33.2723ZM11.4981 24.3183H15.3642V15.5678H15.006C12.8522 17.8574 11.5242 20.9329 11.4981 24.3183ZM33.4757 24.3183H37.3419C37.3157 20.9329 35.9878 17.8574 33.834 15.5678H33.4757V24.3183ZM37.5454 24.3183H45.482C45.4672 21.1938 44.7721 18.2301 43.5372 15.5678H34.1115C36.2233 17.8785 37.5198 20.9472 37.5454 24.3183ZM3.35799 24.3183H11.2946C11.3202 20.9472 12.6166 17.8785 14.7285 15.5678H5.30275C4.06786 18.2301 3.37276 21.1938 3.35799 24.3183ZM43.7614 15.5678H45.4822V21.4661C45.1936 19.389 44.6049 17.4078 43.7614 15.5678ZM33.2722 15.3643V15.006C30.9826 12.8522 27.9071 11.5243 24.5217 11.4981V15.3643H33.2722ZM24.3182 15.3643V11.4981C20.9329 11.5243 17.8574 12.8522 15.5677 15.006V15.3643H24.3182ZM3.35775 15.5678H5.0786C4.23507 17.4078 3.64639 19.389 3.35775 21.4661V15.5678ZM15.5677 5.07861V3.35775H21.4661C19.389 3.6464 17.4078 4.23508 15.5677 5.07861ZM33.2722 5.07861C31.4322 4.23508 29.451 3.6464 27.3739 3.35775H33.2722V5.07861ZM15.5677 45.4823H21.4661C19.389 45.1936 17.4078 44.6049 15.5677 43.7614V45.4823ZM27.3738 45.4823H33.2722V43.7614C31.4322 44.6049 29.451 45.1936 27.3738 45.4823ZM15.5677 43.5373V34.1115C17.8785 36.2234 20.9472 37.5198 24.3182 37.5454V45.482C21.1938 45.4672 18.2301 44.7721 15.5677 43.5373ZM15.5677 5.30275V14.7285C17.8785 12.6167 20.9472 11.3202 24.3182 11.2946V3.35799C21.1938 3.37277 18.2301 4.06787 15.5677 5.30275ZM24.5217 45.482C27.6462 45.4672 30.6099 44.7721 33.2722 43.5372V34.1115C30.9615 36.2234 27.8928 37.5198 24.5217 37.5454V45.482ZM24.5217 11.2946C27.8928 11.3202 30.9615 12.6167 33.2722 14.7285V5.30276C30.6099 4.06787 27.6462 3.37277 24.5217 3.35799V11.2946Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9244 3.34033H28.0756C32.1503 3.34033 33.9265 3.35367 35.8345 3.95123C37.7884 4.67167 39.3283 6.21158 40.0488 8.16546C40.6463 10.0732 40.6597 11.85 40.6597 15.9244V28.0756C40.6597 32.1503 40.6464 33.9265 40.0488 35.8345C39.3283 37.7885 37.7883 39.3284 35.8344 40.0485C33.9265 40.6463 32.1504 40.6597 28.0756 40.6597H15.9244C11.8496 40.6597 10.0732 40.6463 8.16557 40.0484C6.21171 39.3284 4.67172 37.7885 3.95125 35.8345C3.35368 33.9265 3.34035 32.1502 3.34035 28.0756V15.9244C3.34035 11.85 3.35369 10.0732 3.95124 8.16555C4.67168 6.21162 6.21163 4.67166 8.16557 3.95123C10.0732 3.35368 11.8497 3.34033 15.9244 3.34033Z",
    stroke: "white",
    strokeWidth: 0.814
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ddii_3102_20111)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3371 9.90001H25.6628C28.0923 9.90001 29.3067 9.90001 30.6146 10.3134C32.0424 10.8331 33.1669 11.9576 33.6865 13.3854C34.1 14.693 34.1 15.9079 34.1 18.3371V25.6629C34.1 28.0924 34.1 29.3068 33.6865 30.6146C33.1669 32.0424 32.0424 33.1669 30.6146 33.6864C29.3067 34.1 28.0923 34.1 25.6628 34.1H18.3371C15.9076 34.1 14.693 34.1 13.3854 33.6864C11.9576 33.1669 10.8331 32.0424 10.3134 30.6146C9.89996 29.3068 9.89996 28.0924 9.89996 25.6629V18.3371C9.89996 15.9079 9.89996 14.693 10.3134 13.3854C10.8331 11.9576 11.9576 10.8331 13.3854 10.3134C14.693 9.90001 15.9076 9.90001 18.3371 9.90001Z",
    fill: "url(#paint1_linear_3102_20111)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_3102_20111)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.943 26.2515C19.943 27.0382 19.3052 27.676 18.5185 27.676C17.7318 27.676 17.094 27.0382 17.094 26.2515C17.094 25.4648 17.7318 24.827 18.5185 24.827C19.3052 24.827 19.943 25.4648 19.943 26.2515ZM31.746 26.2515C31.746 27.0382 31.1082 27.676 30.3215 27.676C29.5348 27.676 28.897 27.0382 28.897 26.2515C28.897 25.4648 29.5348 24.827 30.3215 24.827C31.1082 24.827 31.746 25.4648 31.746 26.2515ZM22.152 29.0956C22.7656 29.1989 23.5928 29.304 24.42 29.304C25.2472 29.304 26.0744 29.1989 26.688 29.0956C27.0491 29.0347 27.2733 29.3994 26.9894 29.6306C26.4592 30.0626 25.613 30.525 24.42 30.525C23.227 30.525 22.3808 30.0626 21.8506 29.6306C21.5667 29.3994 21.7909 29.0347 22.152 29.0956Z",
    fill: "url(#paint2_linear_3102_20111)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3102_20111",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 10,
    width: 24,
    height: 24
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5591 10.6333H25.4408C27.7231 10.6333 28.8639 10.6333 30.0925 11.0217C31.4337 11.5099 32.4901 12.5662 32.9783 13.9075C33.3666 15.1359 33.3666 16.2771 33.3666 18.5591V25.4409C33.3666 27.7231 33.3666 28.864 32.9783 30.0925C32.4901 31.4338 31.4337 32.4901 30.0925 32.9781C28.8639 33.3667 27.7231 33.3667 25.4408 33.3667H18.5591C16.2769 33.3667 15.1358 33.3667 13.9075 32.9781C12.5662 32.4901 11.5099 31.4338 11.0217 30.0925C10.6333 28.864 10.6333 27.7231 10.6333 25.4409V18.5591C10.6333 16.2771 10.6333 15.1359 11.0217 13.9075C11.5099 12.5662 12.5662 11.5099 13.9075 11.0217C15.1358 10.6333 16.2769 10.6333 18.5591 10.6333Z",
    fill: "url(#paint3_linear_3102_20111)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3102_20111)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11.396,
    cy: 17.501,
    r: 0.8547,
    fill: "url(#paint4_radial_3102_20111)",
    stroke: "url(#paint5_linear_3102_20111)",
    strokeWidth: 0.0814
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.396,
    cy: 13.431,
    r: 0.8547,
    fill: "url(#paint6_radial_3102_20111)",
    stroke: "url(#paint7_linear_3102_20111)",
    strokeWidth: 0.0814
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.652,
    cy: 17.501,
    r: 0.8547,
    fill: "url(#paint8_radial_3102_20111)",
    stroke: "url(#paint9_linear_3102_20111)",
    strokeWidth: 0.0814
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.024,
    cy: 15.466,
    r: 0.8547,
    fill: "url(#paint10_radial_3102_20111)",
    stroke: "url(#paint11_linear_3102_20111)",
    strokeWidth: 0.0814
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.652,
    cy: 13.431,
    r: 0.8547,
    fill: "url(#paint12_radial_3102_20111)",
    stroke: "url(#paint13_linear_3102_20111)",
    strokeWidth: 0.0814
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.908,
    cy: 17.501,
    r: 0.8547,
    fill: "url(#paint14_radial_3102_20111)",
    stroke: "url(#paint15_linear_3102_20111)",
    strokeWidth: 0.0814
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.2799,
    cy: 15.466,
    r: 0.8547,
    fill: "url(#paint16_radial_3102_20111)",
    stroke: "url(#paint17_linear_3102_20111)",
    strokeWidth: 0.0814
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.908,
    cy: 13.431,
    r: 0.8547,
    fill: "url(#paint18_radial_3102_20111)",
    stroke: "url(#paint19_linear_3102_20111)",
    strokeWidth: 0.0814
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.2799,
    cy: 11.396,
    r: 0.8547,
    fill: "url(#paint20_radial_3102_20111)",
    stroke: "url(#paint21_linear_3102_20111)",
    strokeWidth: 0.0814
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.164,
    cy: 17.501,
    r: 0.8547,
    fill: "url(#paint22_radial_3102_20111)",
    stroke: "url(#paint23_linear_3102_20111)",
    strokeWidth: 0.0814
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.536,
    cy: 15.466,
    r: 0.8547,
    fill: "url(#paint24_radial_3102_20111)",
    stroke: "url(#paint25_linear_3102_20111)",
    strokeWidth: 0.0814
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.164,
    cy: 13.431,
    r: 0.8547,
    fill: "url(#paint26_radial_3102_20111)",
    stroke: "url(#paint27_linear_3102_20111)",
    strokeWidth: 0.0814
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.536,
    cy: 11.396,
    r: 0.8547,
    fill: "url(#paint28_radial_3102_20111)",
    stroke: "url(#paint29_linear_3102_20111)",
    strokeWidth: 0.0814
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.42,
    cy: 17.501,
    r: 0.8547,
    fill: "url(#paint30_radial_3102_20111)",
    stroke: "url(#paint31_linear_3102_20111)",
    strokeWidth: 0.0814
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.792,
    cy: 15.466,
    r: 0.8547,
    fill: "url(#paint32_radial_3102_20111)",
    stroke: "url(#paint33_linear_3102_20111)",
    strokeWidth: 0.0814
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.42,
    cy: 13.431,
    r: 0.8547,
    fill: "url(#paint34_radial_3102_20111)",
    stroke: "url(#paint35_linear_3102_20111)",
    strokeWidth: 0.0814
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.792,
    cy: 11.396,
    r: 0.8547,
    fill: "url(#paint36_radial_3102_20111)",
    stroke: "url(#paint37_linear_3102_20111)",
    strokeWidth: 0.0814
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.6759,
    cy: 17.501,
    r: 0.8547,
    fill: "url(#paint38_radial_3102_20111)",
    stroke: "url(#paint39_linear_3102_20111)",
    strokeWidth: 0.0814
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.0479,
    cy: 15.466,
    r: 0.8547,
    fill: "url(#paint40_radial_3102_20111)",
    stroke: "url(#paint41_linear_3102_20111)",
    strokeWidth: 0.0814
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.6759,
    cy: 13.431,
    r: 0.8547,
    fill: "url(#paint42_radial_3102_20111)",
    stroke: "url(#paint43_linear_3102_20111)",
    strokeWidth: 0.0814
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.0479,
    cy: 11.396,
    r: 0.8547,
    fill: "url(#paint44_radial_3102_20111)",
    stroke: "url(#paint45_linear_3102_20111)",
    strokeWidth: 0.0814
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.932,
    cy: 17.501,
    r: 0.8547,
    fill: "url(#paint46_radial_3102_20111)",
    stroke: "url(#paint47_linear_3102_20111)",
    strokeWidth: 0.0814
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.304,
    cy: 15.466,
    r: 0.8547,
    fill: "url(#paint48_radial_3102_20111)",
    stroke: "url(#paint49_linear_3102_20111)",
    strokeWidth: 0.0814
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.932,
    cy: 13.431,
    r: 0.8547,
    fill: "url(#paint50_radial_3102_20111)",
    stroke: "url(#paint51_linear_3102_20111)",
    strokeWidth: 0.0814
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.304,
    cy: 11.396,
    r: 0.8547,
    fill: "url(#paint52_radial_3102_20111)",
    stroke: "url(#paint53_linear_3102_20111)",
    strokeWidth: 0.0814
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.188,
    cy: 17.501,
    r: 0.8547,
    fill: "url(#paint54_radial_3102_20111)",
    stroke: "url(#paint55_linear_3102_20111)",
    strokeWidth: 0.0814
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.56,
    cy: 15.466,
    r: 0.8547,
    fill: "url(#paint56_radial_3102_20111)",
    stroke: "url(#paint57_linear_3102_20111)",
    strokeWidth: 0.0814
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.188,
    cy: 13.431,
    r: 0.8547,
    fill: "url(#paint58_radial_3102_20111)",
    stroke: "url(#paint59_linear_3102_20111)",
    strokeWidth: 0.0814
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.56,
    cy: 11.396,
    r: 0.8547,
    fill: "url(#paint60_radial_3102_20111)",
    stroke: "url(#paint61_linear_3102_20111)",
    strokeWidth: 0.0814
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3102_20111)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48.84,
    height: 48.84,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 29.1895,
    width: 48.84,
    height: 19.6505,
    fill: "url(#paint62_linear_3102_20111)",
    fillOpacity: 0.05
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3102_20111",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 10,
    width: 24,
    height: 24
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5298 28.5344L18.6075 30.6108L19.3499 31.3861C19.934 31.9956 19.9149 32.9649 19.3074 33.5505C18.6994 34.1365 17.7337 34.1173 17.15 33.5078L14.2025 30.4312L18.6313 26.2582L20.5298 28.5344Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5298 28.5344L18.6075 30.6108L19.3499 31.3861C19.934 31.9956 19.9149 32.9649 19.3074 33.5505C18.6994 34.1365 17.7337 34.1173 17.15 33.5078L14.2025 30.4312L18.6313 26.2582L20.5298 28.5344Z",
    fill: "url(#paint63_linear_3102_20111)",
    fillOpacity: 0.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9782 20.0505C20.4244 20.0505 19.1655 18.7871 19.1655 17.2288C19.1655 15.6704 20.4244 14.4066 21.9782 14.4066C23.5315 14.4066 24.7908 15.6704 24.7908 17.2288C24.7908 18.7871 23.5315 20.0505 21.9782 20.0505ZM29.6993 28.386C29.1152 27.7765 28.149 27.7574 27.5419 28.3434L26.7696 29.0878L23.685 25.8797C25.9478 23.6797 29.3186 20.0462 29.3186 17.4237C29.3186 13.336 26.0155 10.0222 21.9409 10.0222C17.8667 10.0222 14.5632 13.336 14.5632 17.4237C14.5632 21.5114 22.7531 29.5024 22.7531 29.5024L26.5905 33.507L29.6564 30.5504C30.2639 29.9644 30.283 28.9956 29.6993 28.386Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9782 20.0505C20.4244 20.0505 19.1655 18.7871 19.1655 17.2288C19.1655 15.6704 20.4244 14.4066 21.9782 14.4066C23.5315 14.4066 24.7908 15.6704 24.7908 17.2288C24.7908 18.7871 23.5315 20.0505 21.9782 20.0505ZM29.6993 28.386C29.1152 27.7765 28.149 27.7574 27.5419 28.3434L26.7696 29.0878L23.685 25.8797C25.9478 23.6797 29.3186 20.0462 29.3186 17.4237C29.3186 13.336 26.0155 10.0222 21.9409 10.0222C17.8667 10.0222 14.5632 13.336 14.5632 17.4237C14.5632 21.5114 22.7531 29.5024 22.7531 29.5024L26.5905 33.507L29.6564 30.5504C30.2639 29.9644 30.283 28.9956 29.6993 28.386Z",
    fill: "url(#paint64_linear_3102_20111)",
    fillOpacity: 0.2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3708 21.0861C13.1804 21.0861 12.9961 20.9826 12.902 20.8012C12.3318 19.7074 12.0308 18.4723 12.0308 17.2303C12.0308 15.9621 12.3444 14.704 12.9367 13.592C13.0742 13.334 13.3951 13.237 13.6522 13.3744C13.9098 13.5128 14.0074 13.8343 13.8695 14.0927C13.3591 15.0511 13.0889 16.1357 13.0889 17.2303C13.0889 18.3175 13.3413 19.3538 13.8392 20.31C13.9749 20.5697 13.8743 20.8903 13.6154 21.0256C13.5373 21.0665 13.4532 21.0861 13.3708 21.0861Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3708 21.0861C13.1804 21.0861 12.9961 20.9826 12.902 20.8012C12.3318 19.7074 12.0308 18.4723 12.0308 17.2303C12.0308 15.9621 12.3444 14.704 12.9367 13.592C13.0742 13.334 13.3951 13.237 13.6522 13.3744C13.9098 13.5128 14.0074 13.8343 13.8695 14.0927C13.3591 15.0511 13.0889 16.1357 13.0889 17.2303C13.0889 18.3175 13.3413 19.3538 13.8392 20.31C13.9749 20.5697 13.8743 20.8903 13.6154 21.0256C13.5373 21.0665 13.4532 21.0861 13.3708 21.0861Z",
    fill: "url(#paint65_linear_3102_20111)",
    fillOpacity: 0.2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5847 21.0861C30.5027 21.0861 30.4186 21.0665 30.3405 21.0256C30.0816 20.8903 29.981 20.5697 30.1168 20.31C30.6142 19.3538 30.867 18.3175 30.867 17.2303C30.867 16.1357 30.5968 15.0511 30.0864 14.0927C29.9485 13.8343 30.0457 13.5128 30.3032 13.3744C30.5608 13.237 30.8813 13.334 31.0188 13.592C31.6116 14.704 31.9247 15.9621 31.9247 17.2303C31.9247 18.4723 31.6237 19.7074 31.0539 20.8012C30.9594 20.9826 30.7751 21.0861 30.5847 21.0861Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5847 21.0861C30.5027 21.0861 30.4186 21.0665 30.3405 21.0256C30.0816 20.8903 29.981 20.5697 30.1168 20.31C30.6142 19.3538 30.867 18.3175 30.867 17.2303C30.867 16.1357 30.5968 15.0511 30.0864 14.0927C29.9485 13.8343 30.0457 13.5128 30.3032 13.3744C30.5608 13.237 30.8813 13.334 31.0188 13.592C31.6116 14.704 31.9247 15.9621 31.9247 17.2303C31.9247 18.4723 31.6237 19.7074 31.0539 20.8012C30.9594 20.9826 30.7751 21.0861 30.5847 21.0861Z",
    fill: "url(#paint66_linear_3102_20111)",
    fillOpacity: 0.2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8965 19.9612C32.8141 19.9612 32.7299 19.9416 32.6523 19.9007C32.393 19.7654 32.2928 19.4448 32.4281 19.185C32.746 18.5742 32.9069 17.913 32.9069 17.2186C32.9069 16.5204 32.7347 15.8273 32.4086 15.2161C32.2711 14.9577 32.3678 14.6366 32.6259 14.4978C32.883 14.3599 33.2039 14.4574 33.3414 14.7153C33.7495 15.4802 33.965 16.3459 33.965 17.2186C33.965 18.0735 33.7573 18.9231 33.3657 19.6762C33.2711 19.8576 33.0868 19.9612 32.8965 19.9612Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8965 19.9612C32.8141 19.9612 32.7299 19.9416 32.6523 19.9007C32.393 19.7654 32.2928 19.4448 32.4281 19.185C32.746 18.5742 32.9069 17.913 32.9069 17.2186C32.9069 16.5204 32.7347 15.8273 32.4086 15.2161C32.2711 14.9577 32.3678 14.6366 32.6259 14.4978C32.883 14.3599 33.2039 14.4574 33.3414 14.7153C33.7495 15.4802 33.965 16.3459 33.965 17.2186C33.965 18.0735 33.7573 18.9231 33.3657 19.6762C33.2711 19.8576 33.0868 19.9612 32.8965 19.9612Z",
    fill: "url(#paint67_linear_3102_20111)",
    fillOpacity: 0.2
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0899 19.9609C10.8995 19.9609 10.7152 19.8573 10.6207 19.6759C10.2291 18.9228 10.0214 18.0732 10.0214 17.2183C10.0214 16.3456 10.2373 15.4798 10.6454 14.715C10.7829 14.457 11.1029 14.3596 11.3609 14.4975C11.6185 14.6363 11.7156 14.9574 11.5777 15.2158C11.2516 15.827 11.0795 16.5196 11.0795 17.2183C11.0795 17.9126 11.2408 18.5739 11.5582 19.1847C11.694 19.4445 11.5933 19.7651 11.3345 19.9004C11.2564 19.9413 11.1723 19.9609 11.0899 19.9609Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0899 19.9609C10.8995 19.9609 10.7152 19.8573 10.6207 19.6759C10.2291 18.9228 10.0214 18.0732 10.0214 17.2183C10.0214 16.3456 10.2373 15.4798 10.6454 14.715C10.7829 14.457 11.1029 14.3596 11.3609 14.4975C11.6185 14.6363 11.7156 14.9574 11.5777 15.2158C11.2516 15.827 11.0795 16.5196 11.0795 17.2183C11.0795 17.9126 11.2408 18.5739 11.5582 19.1847C11.694 19.4445 11.5933 19.7651 11.3345 19.9004C11.2564 19.9413 11.1723 19.9609 11.0899 19.9609Z",
    fill: "url(#paint68_linear_3102_20111)",
    fillOpacity: 0.2
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3102_20111)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -0.516052,
    y: -0.514969,
    width: 49.8697,
    height: 49.8697,
    fill: "url(#paint69_linear_3102_20111)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_3102_20111)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.3961,
    cy: 9.13122,
    rx: 9.76459,
    ry: 11.4117,
    transform: "rotate(-17.1693 30.3961 9.13122)",
    fill: "#F69E5E",
    fillOpacity: 0.3
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_3102_20111)"
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 49.247,
    height: 49.247,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 29.4328,
    width: 49.247,
    height: 19.8142,
    fill: "url(#paint70_linear_3102_20111)",
    fillOpacity: 0.05
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_3102_20111",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 28,
    height: 28
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3133 29.5012L18.1065 31.8849L18.9588 32.7749C19.6293 33.4746 19.6074 34.5873 18.91 35.2595C18.212 35.9322 17.1034 35.9102 16.4334 35.2105L13.0497 31.6787L18.1339 26.8882L20.3133 29.5012Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3133 29.5012L18.1065 31.8849L18.9588 32.7749C19.6293 33.4746 19.6074 34.5873 18.91 35.2595C18.212 35.9322 17.1034 35.9102 16.4334 35.2105L13.0497 31.6787L18.1339 26.8882L20.3133 29.5012Z",
    fill: "url(#paint71_linear_3102_20111)",
    fillOpacity: 0.2
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9759 19.7621C20.1923 19.7621 18.7471 18.3118 18.7471 16.5229C18.7471 14.7339 20.1923 13.2831 21.9759 13.2831C23.7591 13.2831 25.2047 14.7339 25.2047 16.5229C25.2047 18.3118 23.7591 19.7621 21.9759 19.7621ZM30.8395 29.3309C30.1689 28.6313 29.0598 28.6093 28.3629 29.282L27.4763 30.1365L23.9353 26.4538C26.5329 23.9282 30.4024 19.7571 30.4024 16.7466C30.4024 12.0541 26.6106 8.25 21.9331 8.25C17.2562 8.25 13.4638 12.0541 13.4638 16.7466C13.4638 21.4391 22.8655 30.6125 22.8655 30.6125L27.2707 35.2096L30.7902 31.8155C31.4876 31.1428 31.5095 30.0306 30.8395 29.3309Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9759 19.7621C20.1923 19.7621 18.7471 18.3118 18.7471 16.5229C18.7471 14.7339 20.1923 13.2831 21.9759 13.2831C23.7591 13.2831 25.2047 14.7339 25.2047 16.5229C25.2047 18.3118 23.7591 19.7621 21.9759 19.7621ZM30.8395 29.3309C30.1689 28.6313 29.0598 28.6093 28.3629 29.282L27.4763 30.1365L23.9353 26.4538C26.5329 23.9282 30.4024 19.7571 30.4024 16.7466C30.4024 12.0541 26.6106 8.25 21.9331 8.25C17.2562 8.25 13.4638 12.0541 13.4638 16.7466C13.4638 21.4391 22.8655 30.6125 22.8655 30.6125L27.2707 35.2096L30.7902 31.8155C31.4876 31.1428 31.5095 30.0306 30.8395 29.3309Z",
    fill: "url(#paint72_linear_3102_20111)",
    fillOpacity: 0.2
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M12.095 20.9509C11.8765 20.9509 11.6649 20.8321 11.5569 20.6238C10.9023 19.3683 10.5568 17.9504 10.5568 16.5246C10.5568 15.0688 10.9167 13.6245 11.5967 12.3479C11.7545 12.0518 12.1229 11.9404 12.4181 12.0982C12.7138 12.2571 12.8258 12.6261 12.6675 12.9228C12.0816 14.023 11.7715 15.268 11.7715 16.5246C11.7715 17.7726 12.0612 18.9622 12.6327 20.06C12.7885 20.3581 12.673 20.7262 12.3758 20.8815C12.2862 20.9285 12.1896 20.9509 12.095 20.9509Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M12.095 20.9509C11.8765 20.9509 11.6649 20.8321 11.5569 20.6238C10.9023 19.3683 10.5568 17.9504 10.5568 16.5246C10.5568 15.0688 10.9167 13.6245 11.5967 12.3479C11.7545 12.0518 12.1229 11.9404 12.4181 12.0982C12.7138 12.2571 12.8258 12.6261 12.6675 12.9228C12.0816 14.023 11.7715 15.268 11.7715 16.5246C11.7715 17.7726 12.0612 18.9622 12.6327 20.06C12.7885 20.3581 12.673 20.7262 12.3758 20.8815C12.2862 20.9285 12.1896 20.9509 12.095 20.9509Z",
    fill: "url(#paint73_linear_3102_20111)",
    fillOpacity: 0.2
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8559 20.9509C31.7618 20.9509 31.6652 20.9285 31.5756 20.8815C31.2784 20.7262 31.1629 20.3581 31.3187 20.06C31.8897 18.9622 32.1799 17.7726 32.1799 16.5246C32.1799 15.268 31.8698 14.023 31.2839 12.9228C31.1256 12.6261 31.2371 12.2571 31.5328 12.0982C31.8285 11.9404 32.1964 12.0518 32.3542 12.3479C33.0347 13.6245 33.3941 15.0688 33.3941 16.5246C33.3941 17.9504 33.0486 19.3683 32.3945 20.6238C32.286 20.8321 32.0744 20.9509 31.8559 20.9509Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8559 20.9509C31.7618 20.9509 31.6652 20.9285 31.5756 20.8815C31.2784 20.7262 31.1629 20.3581 31.3187 20.06C31.8897 18.9622 32.1799 17.7726 32.1799 16.5246C32.1799 15.268 31.8698 14.023 31.2839 12.9228C31.1256 12.6261 31.2371 12.2571 31.5328 12.0982C31.8285 11.9404 32.1964 12.0518 32.3542 12.3479C33.0347 13.6245 33.3941 15.0688 33.3941 16.5246C33.3941 17.9504 33.0486 19.3683 32.3945 20.6238C32.286 20.8321 32.0744 20.9509 31.8559 20.9509Z",
    fill: "url(#paint74_linear_3102_20111)",
    fillOpacity: 0.2
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5097 19.6595C34.4151 19.6595 34.3185 19.637 34.2294 19.5901C33.9317 19.4348 33.8167 19.0667 33.9721 18.7686C34.337 18.0674 34.5216 17.3083 34.5216 16.5112C34.5216 15.7096 34.324 14.914 33.9497 14.2124C33.7918 13.9157 33.9029 13.5471 34.1991 13.3878C34.4943 13.2295 34.8626 13.3414 35.0205 13.6375C35.4889 14.5155 35.7363 15.5094 35.7363 16.5112C35.7363 17.4925 35.4979 18.4679 35.0483 19.3324C34.9398 19.5407 34.7282 19.6595 34.5097 19.6595Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5097 19.6595C34.4151 19.6595 34.3185 19.637 34.2294 19.5901C33.9317 19.4348 33.8167 19.0667 33.9721 18.7686C34.337 18.0674 34.5216 17.3083 34.5216 16.5112C34.5216 15.7096 34.324 14.914 33.9497 14.2124C33.7918 13.9157 33.9029 13.5471 34.1991 13.3878C34.4943 13.2295 34.8626 13.3414 35.0205 13.6375C35.4889 14.5155 35.7363 15.5094 35.7363 16.5112C35.7363 17.4925 35.4979 18.4679 35.0483 19.3324C34.9398 19.5407 34.7282 19.6595 34.5097 19.6595Z",
    fill: "url(#paint75_linear_3102_20111)",
    fillOpacity: 0.2
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M9.47661 19.6592C9.25807 19.6592 9.0465 19.5403 8.93798 19.332C8.48845 18.4676 8.25 17.4922 8.25 16.5108C8.25 15.509 8.49791 14.5152 8.96635 13.6372C9.12416 13.341 9.49155 13.2292 9.78774 13.3875C10.0834 13.5468 10.195 13.9154 10.0367 14.212C9.6623 14.9137 9.46466 15.7088 9.46466 16.5108C9.46466 17.3079 9.64985 18.067 10.0142 18.7682C10.1701 19.0664 10.0546 19.4344 9.75738 19.5897C9.66777 19.6367 9.5712 19.6592 9.47661 19.6592Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M9.47661 19.6592C9.25807 19.6592 9.0465 19.5403 8.93798 19.332C8.48845 18.4676 8.25 17.4922 8.25 16.5108C8.25 15.509 8.49791 14.5152 8.96635 13.6372C9.12416 13.341 9.49155 13.2292 9.78774 13.3875C10.0834 13.5468 10.195 13.9154 10.0367 14.212C9.6623 14.9137 9.46466 15.7088 9.46466 16.5108C9.46466 17.3079 9.64985 18.067 10.0142 18.7682C10.1701 19.0664 10.0546 19.4344 9.75738 19.5897C9.66777 19.6367 9.5712 19.6592 9.47661 19.6592Z",
    fill: "url(#paint76_linear_3102_20111)",
    fillOpacity: 0.2
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_3102_20111)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.23975,
    y: -4.23914,
    width: 57.7254,
    height: 57.7254,
    fill: "url(#paint77_linear_3102_20111)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_3102_20111)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.5423,
    cy: 6.92632,
    rx: 11.3028,
    ry: 13.2093,
    transform: "rotate(-17.1693 31.5423 6.92632)",
    fill: "#F69E5E",
    fillOpacity: 0.3
  }))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddii_3102_20111",
    x: 5.01596,
    y: 8.27201,
    width: 33.968,
    height: 33.968,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.256
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.442
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3102_20111"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.407
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.6105
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_3102_20111",
    result: "effect2_dropShadow_3102_20111"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_3102_20111",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.221,
    dy: -1.221
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.814
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.114792 0 0 0 0 0.245569 0 0 0 0 0.3625 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow_3102_20111"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.814
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.407
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.816667 0 0 0 0 0.956 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "effect3_innerShadow_3102_20111",
    result: "effect4_innerShadow_3102_20111"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_3102_20111",
    x: 15.466,
    y: 24.827,
    width: 17.908,
    height: 8.954,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.628
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.814
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3102_20111"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3102_20111",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_3102_20111",
    x: 10.0874,
    y: -12.5363,
    width: 40.6174,
    height: 43.335,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.19349,
    result: "effect1_foregroundBlur_3102_20111"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_3102_20111",
    x: 8.03448,
    y: -18.1543,
    width: 47.0156,
    height: 50.1613,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.0116,
    result: "effect1_foregroundBlur_3102_20111"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3102_20111",
    x1: 22,
    y1: 0,
    x2: 22,
    y2: 44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57B8EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2765D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3102_20111",
    x1: 22,
    y1: 9.90001,
    x2: 22,
    y2: 34.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#617489"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0989583,
    stopColor: "#3E5670"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F1011"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3102_20111",
    x1: 24.42,
    y1: 24.827,
    x2: 24.42,
    y2: 30.525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6D7D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3102_20111",
    x1: 22,
    y1: 10.6333,
    x2: 22,
    y2: 17.1778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#617489",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F1011"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_3102_20111",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.4243 16.2155) rotate(90) scale(2.32203)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.283703,
    stopColor: "#0F1011"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.817708,
    stopColor: "#3E5670"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.974871,
    stopColor: "#617489"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3102_20111",
    x1: 11.396,
    y1: 16.687,
    x2: 11.4243,
    y2: 18.344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.219025,
    stopColor: "#384D63",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BB4E0",
    stopOpacity: 0.45
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_3102_20111",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.4243 12.1455) rotate(90) scale(2.32203)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.283703,
    stopColor: "#0F1011"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.817708,
    stopColor: "#3E5670"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.974871,
    stopColor: "#617489"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3102_20111",
    x1: 11.396,
    y1: 12.617,
    x2: 11.4243,
    y2: 14.274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.219025,
    stopColor: "#384D63",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BB4E0",
    stopOpacity: 0.45
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_3102_20111",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.6803 16.2155) rotate(90) scale(2.32203)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.283703,
    stopColor: "#0F1011"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.817708,
    stopColor: "#3E5670"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.974871,
    stopColor: "#617489"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3102_20111",
    x1: 14.652,
    y1: 16.687,
    x2: 14.6803,
    y2: 18.344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.219025,
    stopColor: "#384D63",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BB4E0",
    stopOpacity: 0.45
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_3102_20111",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.0523 14.1805) rotate(90) scale(2.32203)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.283703,
    stopColor: "#0F1011"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.817708,
    stopColor: "#3E5670"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.974871,
    stopColor: "#617489"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_3102_20111",
    x1: 13.024,
    y1: 14.652,
    x2: 13.0523,
    y2: 16.309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.219025,
    stopColor: "#384D63",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BB4E0",
    stopOpacity: 0.45
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_3102_20111",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.6803 12.1455) rotate(90) scale(2.32203)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.283703,
    stopColor: "#0F1011"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.817708,
    stopColor: "#3E5670"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.974871,
    stopColor: "#617489"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_3102_20111",
    x1: 14.652,
    y1: 12.617,
    x2: 14.6803,
    y2: 14.274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.219025,
    stopColor: "#384D63",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BB4E0",
    stopOpacity: 0.45
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_3102_20111",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.9364 16.2155) rotate(90) scale(2.32203)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.283703,
    stopColor: "#0F1011"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.817708,
    stopColor: "#3E5670"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.974871,
    stopColor: "#617489"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_3102_20111",
    x1: 17.908,
    y1: 16.687,
    x2: 17.9364,
    y2: 18.344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.219025,
    stopColor: "#384D63",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BB4E0",
    stopOpacity: 0.45
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_3102_20111",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.3083 14.1805) rotate(90) scale(2.32203)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.283703,
    stopColor: "#0F1011"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.817708,
    stopColor: "#3E5670"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.974871,
    stopColor: "#617489"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_3102_20111",
    x1: 16.2799,
    y1: 14.652,
    x2: 16.3083,
    y2: 16.309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.219025,
    stopColor: "#384D63",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BB4E0",
    stopOpacity: 0.45
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_3102_20111",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.9364 12.1455) rotate(90) scale(2.32203)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.283703,
    stopColor: "#0F1011"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.817708,
    stopColor: "#3E5670"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.974871,
    stopColor: "#617489"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_3102_20111",
    x1: 17.908,
    y1: 12.617,
    x2: 17.9364,
    y2: 14.274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.219025,
    stopColor: "#384D63",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BB4E0",
    stopOpacity: 0.45
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_3102_20111",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.3083 10.1105) rotate(90) scale(2.32203)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.283703,
    stopColor: "#0F1011"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.817708,
    stopColor: "#3E5670"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.974871,
    stopColor: "#617489"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_3102_20111",
    x1: 16.2799,
    y1: 10.582,
    x2: 16.3083,
    y2: 12.239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.219025,
    stopColor: "#384D63",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BB4E0",
    stopOpacity: 0.45
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_3102_20111",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.1924 16.2155) rotate(90) scale(2.32203)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.283703,
    stopColor: "#0F1011"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.817708,
    stopColor: "#3E5670"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.974871,
    stopColor: "#617489"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_3102_20111",
    x1: 21.164,
    y1: 16.687,
    x2: 21.1924,
    y2: 18.344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.219025,
    stopColor: "#384D63",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BB4E0",
    stopOpacity: 0.45
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_3102_20111",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.5644 14.1805) rotate(90) scale(2.32203)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.283703,
    stopColor: "#0F1011"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.817708,
    stopColor: "#3E5670"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.974871,
    stopColor: "#617489"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_3102_20111",
    x1: 19.536,
    y1: 14.652,
    x2: 19.5644,
    y2: 16.309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.219025,
    stopColor: "#384D63",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BB4E0",
    stopOpacity: 0.45
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_3102_20111",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.1924 12.1455) rotate(90) scale(2.32203)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.283703,
    stopColor: "#0F1011"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.817708,
    stopColor: "#3E5670"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.974871,
    stopColor: "#617489"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_3102_20111",
    x1: 21.164,
    y1: 12.617,
    x2: 21.1924,
    y2: 14.274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.219025,
    stopColor: "#384D63",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BB4E0",
    stopOpacity: 0.45
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_3102_20111",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.5644 10.1105) rotate(90) scale(2.32203)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.283703,
    stopColor: "#0F1011"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.817708,
    stopColor: "#3E5670"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.974871,
    stopColor: "#617489"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_3102_20111",
    x1: 19.536,
    y1: 10.582,
    x2: 19.5644,
    y2: 12.239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.219025,
    stopColor: "#384D63",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BB4E0",
    stopOpacity: 0.45
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_3102_20111",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.4483 16.2155) rotate(90) scale(2.32203)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.283703,
    stopColor: "#0F1011"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.817708,
    stopColor: "#3E5670"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.974871,
    stopColor: "#617489"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_3102_20111",
    x1: 24.42,
    y1: 16.687,
    x2: 24.4483,
    y2: 18.344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.219025,
    stopColor: "#384D63",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BB4E0",
    stopOpacity: 0.45
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial_3102_20111",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.8203 14.1805) rotate(90) scale(2.32203)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.283703,
    stopColor: "#0F1011"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.817708,
    stopColor: "#3E5670"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.974871,
    stopColor: "#617489"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_3102_20111",
    x1: 22.792,
    y1: 14.652,
    x2: 22.8203,
    y2: 16.309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.219025,
    stopColor: "#384D63",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BB4E0",
    stopOpacity: 0.45
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_3102_20111",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.4483 12.1455) rotate(90) scale(2.32203)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.283703,
    stopColor: "#0F1011"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.817708,
    stopColor: "#3E5670"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.974871,
    stopColor: "#617489"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_3102_20111",
    x1: 24.42,
    y1: 12.617,
    x2: 24.4483,
    y2: 14.274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.219025,
    stopColor: "#384D63",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BB4E0",
    stopOpacity: 0.45
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint36_radial_3102_20111",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.8203 10.1105) rotate(90) scale(2.32203)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.283703,
    stopColor: "#0F1011"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.817708,
    stopColor: "#3E5670"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.974871,
    stopColor: "#617489"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_3102_20111",
    x1: 22.792,
    y1: 10.582,
    x2: 22.8203,
    y2: 12.239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.219025,
    stopColor: "#384D63",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BB4E0",
    stopOpacity: 0.45
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_radial_3102_20111",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.7043 16.2155) rotate(90) scale(2.32203)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.283703,
    stopColor: "#0F1011"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.817708,
    stopColor: "#3E5670"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.974871,
    stopColor: "#617489"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_3102_20111",
    x1: 27.6759,
    y1: 16.687,
    x2: 27.7043,
    y2: 18.344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.219025,
    stopColor: "#384D63",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BB4E0",
    stopOpacity: 0.45
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint40_radial_3102_20111",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.0763 14.1805) rotate(90) scale(2.32203)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.283703,
    stopColor: "#0F1011"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.817708,
    stopColor: "#3E5670"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.974871,
    stopColor: "#617489"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_3102_20111",
    x1: 26.0479,
    y1: 14.652,
    x2: 26.0763,
    y2: 16.309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.219025,
    stopColor: "#384D63",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BB4E0",
    stopOpacity: 0.45
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint42_radial_3102_20111",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.7043 12.1455) rotate(90) scale(2.32203)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.283703,
    stopColor: "#0F1011"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.817708,
    stopColor: "#3E5670"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.974871,
    stopColor: "#617489"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_3102_20111",
    x1: 27.6759,
    y1: 12.617,
    x2: 27.7043,
    y2: 14.274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.219025,
    stopColor: "#384D63",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BB4E0",
    stopOpacity: 0.45
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint44_radial_3102_20111",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.0763 10.1105) rotate(90) scale(2.32203)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.283703,
    stopColor: "#0F1011"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.817708,
    stopColor: "#3E5670"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.974871,
    stopColor: "#617489"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_3102_20111",
    x1: 26.0479,
    y1: 10.582,
    x2: 26.0763,
    y2: 12.239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.219025,
    stopColor: "#384D63",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BB4E0",
    stopOpacity: 0.45
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint46_radial_3102_20111",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.9604 16.2155) rotate(90) scale(2.32203)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.283703,
    stopColor: "#0F1011"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.817708,
    stopColor: "#3E5670"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.974871,
    stopColor: "#617489"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_3102_20111",
    x1: 30.932,
    y1: 16.687,
    x2: 30.9604,
    y2: 18.344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.219025,
    stopColor: "#384D63",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BB4E0",
    stopOpacity: 0.45
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint48_radial_3102_20111",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.3324 14.1805) rotate(90) scale(2.32203)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.283703,
    stopColor: "#0F1011"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.817708,
    stopColor: "#3E5670"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.974871,
    stopColor: "#617489"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_3102_20111",
    x1: 29.304,
    y1: 14.652,
    x2: 29.3324,
    y2: 16.309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.219025,
    stopColor: "#384D63",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BB4E0",
    stopOpacity: 0.45
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint50_radial_3102_20111",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.9604 12.1455) rotate(90) scale(2.32203)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.283703,
    stopColor: "#0F1011"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.817708,
    stopColor: "#3E5670"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.974871,
    stopColor: "#617489"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_3102_20111",
    x1: 30.932,
    y1: 12.617,
    x2: 30.9604,
    y2: 14.274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.219025,
    stopColor: "#384D63",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BB4E0",
    stopOpacity: 0.45
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint52_radial_3102_20111",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.3324 10.1105) rotate(90) scale(2.32203)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.283703,
    stopColor: "#0F1011"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.817708,
    stopColor: "#3E5670"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.974871,
    stopColor: "#617489"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_3102_20111",
    x1: 29.304,
    y1: 10.582,
    x2: 29.3324,
    y2: 12.239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.219025,
    stopColor: "#384D63",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BB4E0",
    stopOpacity: 0.45
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint54_radial_3102_20111",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.2163 16.2155) rotate(90) scale(2.32203)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.283703,
    stopColor: "#0F1011"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.817708,
    stopColor: "#3E5670"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.974871,
    stopColor: "#617489"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_3102_20111",
    x1: 34.188,
    y1: 16.687,
    x2: 34.2163,
    y2: 18.344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.219025,
    stopColor: "#384D63",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BB4E0",
    stopOpacity: 0.45
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint56_radial_3102_20111",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.5883 14.1805) rotate(90) scale(2.32203)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.283703,
    stopColor: "#0F1011"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.817708,
    stopColor: "#3E5670"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.974871,
    stopColor: "#617489"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_3102_20111",
    x1: 32.56,
    y1: 14.652,
    x2: 32.5883,
    y2: 16.309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.219025,
    stopColor: "#384D63",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BB4E0",
    stopOpacity: 0.45
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint58_radial_3102_20111",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.2163 12.1455) rotate(90) scale(2.32203)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.283703,
    stopColor: "#0F1011"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.817708,
    stopColor: "#3E5670"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.974871,
    stopColor: "#617489"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_3102_20111",
    x1: 34.188,
    y1: 12.617,
    x2: 34.2163,
    y2: 14.274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.219025,
    stopColor: "#384D63",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BB4E0",
    stopOpacity: 0.45
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint60_radial_3102_20111",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.5883 10.1105) rotate(90) scale(2.32203)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.283703,
    stopColor: "#0F1011"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.817708,
    stopColor: "#3E5670"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.974871,
    stopColor: "#617489"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_3102_20111",
    x1: 32.56,
    y1: 10.582,
    x2: 32.5883,
    y2: 12.239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.219025,
    stopColor: "#384D63",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BB4E0",
    stopOpacity: 0.45
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_3102_20111",
    x1: 24.42,
    y1: 35.5569,
    x2: 24.42,
    y2: 51.5109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_3102_20111",
    x1: 3.02336,
    y1: 37.4658,
    x2: 21.2313,
    y2: 20.1353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.861506,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_3102_20111",
    x1: 3.02336,
    y1: 37.4658,
    x2: 21.2313,
    y2: 20.1353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.861506,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_3102_20111",
    x1: 3.02336,
    y1: 37.4658,
    x2: 21.2313,
    y2: 20.1353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.861506,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_3102_20111",
    x1: 3.02336,
    y1: 37.4658,
    x2: 21.2313,
    y2: 20.1353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.861506,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_3102_20111",
    x1: 3.02336,
    y1: 37.4658,
    x2: 21.2313,
    y2: 20.1353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.861506,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_3102_20111",
    x1: 3.02336,
    y1: 37.4658,
    x2: 21.2313,
    y2: 20.1353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.861506,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_3102_20111",
    x1: 6.56992,
    y1: 2.33403,
    x2: 28.12,
    y2: 49.3547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#F69E5E",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.598958,
    stopColor: "#25C9CA",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_3102_20111",
    x1: 24.6235,
    y1: 35.8532,
    x2: 24.6235,
    y2: 51.9402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_3102_20111",
    x1: 0.216575,
    y1: 39.7541,
    x2: 21.1186,
    y2: 19.8594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.861506,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_3102_20111",
    x1: 0.216575,
    y1: 39.7541,
    x2: 21.1186,
    y2: 19.8594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.861506,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_3102_20111",
    x1: 0.216575,
    y1: 39.7541,
    x2: 21.1186,
    y2: 19.8594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.861506,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_3102_20111",
    x1: 0.216575,
    y1: 39.7541,
    x2: 21.1186,
    y2: 19.8594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.861506,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_3102_20111",
    x1: 0.216575,
    y1: 39.7541,
    x2: 21.1186,
    y2: 19.8594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.861506,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_3102_20111",
    x1: 0.216575,
    y1: 39.7541,
    x2: 21.1186,
    y2: 19.8594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.861506,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_3102_20111",
    x1: 3.96245,
    y1: -0.941346,
    x2: 28.9073,
    y2: 53.4863,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#F69E5E",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.598958,
    stopColor: "#25C9CA",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3102_20111"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 7.4C0 3.31309 3.31309 0 7.4 0H36.6C40.6869 0 44 3.31309 44 7.4V36.6C44 40.6869 40.6869 44 36.6 44H7.4C3.31309 44 0 40.6869 0 36.6V7.4Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3102_20111"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_3102_20111"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppIcon);
export default __webpack_public_path__ + "static/media/app_icon.ea5888e28e1defbd063a8d6a594d6ca3.svg";
export { ForwardRef as ReactComponent };